





































import { Component, Vue } from "vue-property-decorator";

import FlexibleContentArea from "@/components/layout/FlexibleContentArea.vue";

@Component({
  components: { FlexibleContentArea },
})
export default class EventTabs extends Vue {
  private tabIndex = 0;

  private onClick(tabIndex: number): void {
    this.tabIndex = tabIndex;
  }
}
